import Vue from 'vue'

Vue.filter('dateFormat', function(value) {
    if (value) {
        return `${new Date(value).toLocaleDateString()} ${new Date(value).toLocaleTimeString()}`
    }
})
